import { render, staticRenderFns } from "./countdown.vue?vue&type=template&id=70044f2a&scoped=true&"
import script from "./countdown.vue?vue&type=script&lang=js&"
export * from "./countdown.vue?vue&type=script&lang=js&"
import style0 from "./countdown.vue?vue&type=style&index=0&id=70044f2a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70044f2a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70044f2a')) {
      api.createRecord('70044f2a', component.options)
    } else {
      api.reload('70044f2a', component.options)
    }
    module.hot.accept("./countdown.vue?vue&type=template&id=70044f2a&scoped=true&", function () {
      api.rerender('70044f2a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/withdraw_requests/actions/modals/countdown.vue"
export default component.exports